var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlob5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sw-js-blob-svg",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sw-gradient",
    x1: 0,
    x2: 1,
    y1: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop1",
    stopColor: "rgba(25, 57, 83, 1)",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop2",
    stopColor: "rgba(25, 57, 83, 1)",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#sw-gradient)",
    d: "M11.4,-16.1C17.1,-11.5,25.7,-11.3,27,-8.5C28.2,-5.7,22.1,-0.3,19.1,5.4C16.1,11,16.2,16.8,13.6,17.4C10.9,18,5.5,13.5,-1.1,15C-7.7,16.6,-15.4,24.2,-21.8,24.8C-28.3,25.4,-33.4,19,-36.6,11.3C-39.8,3.7,-41,-5,-37.1,-10.5C-33.1,-15.9,-23.9,-18.1,-16.8,-22.2C-9.8,-26.3,-4.9,-32.4,-1,-31C2.8,-29.6,5.7,-20.6,11.4,-16.1Z",
    width: "100%",
    height: "100%",
    transform: "translate(50 50)",
    strokeWidth: 0,
    style: {
      transition: "0.3s"
    },
    stroke: "url(#sw-gradient)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob5);
export default __webpack_public_path__ + "static/media/blob5.50376174020d208e3250dc1fb59d2c78.svg";
export { ForwardRef as ReactComponent };